<template>
    <div class="notification-module-root bottom-left">
        <Notification
            v-for="n in messages"
            :id="n.id"
            :key="n.id"
            class="mt-3"
            :title="n.title"
            :message="n.message"
            :state="n.state"
            :duration="n.duration"
            :persistent="n.persistent"
            :icon="n.icon"
            :linkHref="n.link && n.link.href ? n.link.href : null"
            :linkText="n.link && n.link.text ? n.link.text : null"
            :playSound="n.playSound"
            @close="emitClose(n)"
        />
    </div>
</template>

<script>
import Notification from './Notification';

export default {
    name: 'NotificationModule',
    components: { Notification },
    data: () => ({}),
    computed: {
        messages() {
            return this.$interfaces.messageModule.getMessages();
        },
    },
    methods: {
        emitClose(message) {
            message.onClose && message.onClose();
        },
    },
};
</script>

<style scoped>
.notification-module-root {
    position: fixed;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    z-index: 10000;
}
.top-left {
    top: 20px;
    left: 20px;
}
.top-right {
    top: 20px;
    right: 20px;
}
.bottom-right {
    bottom: 20px;
    right: 20px;
}
.bottom-left {
    bottom: 20px;
    left: 20px;
}

@media only screen and (max-width: 600px) {
    .notification-module-root {
        left: 4px;
        right: 4px;
        bottom: 4px;
    }
}
</style>
